/** @jsx jsx */
import { memo } from "react";
import { jsx } from "theme-ui";
import { Themed } from "theme-ui";

var Heading = function Heading(_a) {
  var children = _a.children,
      _b = _a.level,
      level = _b === void 0 ? 1 : _b,
      className = _a.className;
  var Tag = Themed["h" + level];
  return jsx(Tag, {
    className: className
  }, children);
};

export default memo(Heading);